



























import Vue from 'vue';
import store from '@/store';

import { BasePacket, BasePacketKind } from '@/models/packet';
import * as Utils from '@/utils';

import PacketLibrary from '@/components/PacketLibrary.vue';
import PacketCopier from '@/components/PacketCopier.vue';

export default Vue.extend({
  props: {
    peerGroupId: {
      type: Number,
      default: null
    }
  },

  components: {
    PacketLibrary,
    PacketCopier
  },

  computed: {
    organizationId(): number {
      return store.state.org.basic.organizationId;
    },

    libraryPackets(): BasePacket[] {
      return store.state.org.org.packets
        .map(op => op.packet)
        .slice()
        .sort(Utils.sortNamed);
    }
  },

  methods: {
    onCopyComplete(packetKind: BasePacketKind) {
      this.$router.push({
        name: 'OrganizationPacketCreator',
        params: {
          organizationId: `${this.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        },
        query: {
          stepNo: '2',
          packetKind: packetKind
        }
      });
    }
  }
});
